import React from 'react';
import { Badge } from '@/components/ui/Badge';
import { cn } from '@/utils/cn';

interface InconsistencyDetailCardProps {
  title: string;
  severity: 'CRITIQUE' | 'MAJEURE' | 'INFORMATION';
  dpeValue: string;
  userValue: string;
  recommendation: string;
  impact: string;
}

export const InconsistencyDetailCard: React.FC<InconsistencyDetailCardProps> = ({
  title,
  severity,
  dpeValue,
  userValue,
  recommendation,
  impact
}) => {
  // Map severity to badge variant and label
  const getSeverityBadge = () => {
    switch (severity) {
      case 'CRITIQUE':
        return <Badge variant="danger" size="sm">CRITIQUE</Badge>;
      case 'MAJEURE':
        return <Badge variant="warning" size="sm">MAJEURE</Badge>;
      case 'INFORMATION':
        return <Badge variant="info" size="sm">PRÉCISION</Badge>;
      default:
        return <Badge variant="default" size="sm">{severity}</Badge>;
    }
  };

  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
      {/* Header */}
      <div className="flex items-start justify-between p-4 border-b border-gray-100">
        <h5 className="font-semibold text-gray-900">{title}</h5>
        {getSeverityBadge()}
      </div>

      {/* Content: DPE officiel vs Votre réalité */}
      <div className="grid grid-cols-2 gap-0 border-b border-gray-200">
        {/* DPE officiel */}
        <div className="p-4 bg-gray-50 border-r border-gray-200">
          <div className="text-xs font-medium text-gray-500 uppercase mb-2">
            📄 DPE officiel
          </div>
          <div className="text-sm text-gray-900">
            {dpeValue}
          </div>
        </div>

        {/* Votre réalité */}
        <div className="p-4 bg-green-50">
          <div className="text-xs font-medium text-gray-500 uppercase mb-2">
            ✓ Votre réalité
          </div>
          <div className="text-sm text-gray-900">
            {userValue}
          </div>
        </div>
      </div>

      {/* Recommendation */}
      <div className="p-4 bg-blue-50">
        <div className="space-y-2">
          <div className="text-xs font-semibold text-blue-900">
            Recommandation :
          </div>
          <p className="text-sm text-blue-800">
            {recommendation}
          </p>
          <div className="text-xs text-blue-700 mt-2">
            <strong>Impact :</strong> {impact}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InconsistencyDetailCard;
